export default "__VITE_ASSET__bd98791d__"